import { TEmployeeApplicationForm } from "@/features/renew-visa/types/employeeApplicationForm";
import { toNumber } from "@/utils/number";
import { useFormContext, useWatch } from "react-hook-form";

type useGetPreventEmployeeApplicationModalStateReturn = {
  alwaysOpenPreventEmployeeApplicationModal: boolean;
};

export const useGetPreventEmployeeApplicationModalState = (): useGetPreventEmployeeApplicationModalStateReturn => {
  const methods = useFormContext<TEmployeeApplicationForm>();

  const { control } = methods;

  const contractStartDateWatchField = useWatch({ control, name: "contractStartDate" });
  const contractEndDateWatchField = useWatch({ control, name: "contractEndDate" });
  const relatedActivityJapaneseCertificationTwoWatchField = useWatch({ control, name: "relatedActivityJapaneseCertificationTwo" });
  const relatedActivitySkillCertificationOneWatchField = useWatch({ control, name: "relatedActivitySkillCertificationOne" });
  const employeeInfoPassportPermanentAddressWatchField = useWatch({ control, name: "employeeInfoPassportPermanentAddress" });
  const contractMonthlySalaryWatchField = useWatch({ control, name: "contractMonthlySalary" });

  const alwaysOpenPreventEmployeeApplicationModal =
    !toNumber(contractMonthlySalaryWatchField) ||
    !relatedActivitySkillCertificationOneWatchField ||
    !contractStartDateWatchField ||
    !contractEndDateWatchField ||
    !relatedActivityJapaneseCertificationTwoWatchField ||
    !employeeInfoPassportPermanentAddressWatchField;

  return { alwaysOpenPreventEmployeeApplicationModal };
};
